module.exports = __webpack_public_path__ + "media/images/logo-4ffef6dd74e5038b02c62a86817033c2.svg";